import { injectReducer } from '../../store/reducers'

import NotFound from './components/NotFound'

export default (store) => ({
  path : '*',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */


      /*  Add the reducer to the store on key 'counter'  */
      //injectReducer(store, { key: 'counter', reducer })

      /*  Return getComponent   */
      cb(null, NotFound)

    /* Webpack named bundle   */
    }, 'NotFound')
  }
})



// WEBPACK FOOTER //
// ./src/routes/NotFound/index.js